<template>
  <v-layout
    flex 
    align-center 
    justify-center>
    <v-card 
      :class="`elevation-${elevation}`"
      class="white lighten-4">
      <v-card-text class="pa-5">
        <template v-if="items.length > 0">
          <template v-for="(item,i) in items" >
            <div :key="`loading_${i}`">
              <template v-if="item.finish">
                <v-icon class="mr-1">done</v-icon>
                <span>
                  {{ $t('general.loading') }} {{ item.text }}.
                </span>
              </template>
              <template v-else>
                <v-progress-circular 
                  :size="20" 
                  :width="7" 
                  :color="color"
                  class="mr-2"
                  indeterminate />
                <span>
                  {{ $t('general.loading') }} {{ item.text }}...
                </span>
              </template>
            </div>
          </template>
        </template>
        <template v-else>
          <v-progress-circular 
            :size="70" 
            :width="7" 
            :color="color"
            indeterminate />
        </template>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
// const debug = require('debug')('OD::Loading')

export default {
  name: 'Loading',
  props: {
    text: {
      type: String,
      default: '',
    },
    texts: {
      type: Array,
      default: () => [],
    },
    finish: {
      type: Boolean,
      default: false,
    },
    elevation: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      color: 'grey',
    }
  },
  computed: {
    items() {
      let items = []
      if (this.text) {
        items.push({ text: this.text, finish: this.finish })
      } else {
        if (this.texts.length > 0) {
          items = this.texts
        }
      }
      return items
    },
  },
}
</script>
